'use client';

import { c as _c } from "react/compiler-runtime";
import { useActionState, useEffect, useRef } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { subscribeToNewsletter } from '@/features/crm/actions';
export function NewsletterForm() {
  const $ = _c(14);
  const [state, formAction, isPending] = useActionState(subscribeToNewsletter, null);
  const formRef = useRef(null);
  let t0;
  if ($[0] !== state?.success) {
    t0 = () => {
      if (state?.success && formRef.current) {
        formRef.current.reset();
      }
    };
    $[0] = state?.success;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const t1 = state?.success;
  let t2;
  if ($[2] !== t1) {
    t2 = [t1];
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  useEffect(t0, t2);
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Input type="email" name="email" placeholder="Email" required={true} className="w-full border-0 bg-transparent px-4 py-3 text-[0.8rem] uppercase focus-visible:ring-0 focus-visible:ring-offset-0 md:text-base" />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = isPending ? "Signing Up..." : "Sign Up";
  let t5;
  if ($[5] !== isPending || $[6] !== t4) {
    t5 = <form ref={formRef} className="flex min-w-[280px] gap-2 border-[1.78px] border-christ-white-900" action={formAction}>{t3}<Button type="submit" disabled={isPending} className="shrink-0 bg-christ-white-900 px-10 py-3 font-bold text-christ-black-900 uppercase transition-all duration-300 hover:bg-christ-white-900 hover:opacity-90 md:px-4">{t4}</Button></form>;
    $[5] = isPending;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== state) {
    t6 = (state?.error || state?.success) && <div className="mt-1 text-[0.9rem]">{state?.error && <p className="text-christ-red">{state.message}</p>}{state?.success && <p className="text-christ-white-900">{state.message}</p>}</div>;
    $[8] = state;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <p className="mt-4 max-w-[50ch]">Be in the know. Sign up for our community, hear directly from the filmmakers, podcasts, events, merch, and more.</p>;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t5 || $[12] !== t6) {
    t8 = <div className="flex flex-col font-medium text-sm">{t5}{t6}{t7}</div>;
    $[11] = t5;
    $[12] = t6;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  return t8;
}